import React from "react";
import { cn } from "@/lib/utils";

type GuesteriaPartnerRegionValueProps = {
  city?: string;
  flagEmoji?: string;
  className?: string;
};

export function GuesteriaPartnerRegionValue({
  city,
  flagEmoji,
  className,
}: GuesteriaPartnerRegionValueProps): React.JSX.Element | null {
  const trimmedCity = city?.trim();
  if (!trimmedCity) {
    return null;
  }

  return (
    <div className={cn("inline-flex min-w-0 items-center gap-1", className)}>
      {flagEmoji ? (
        <span aria-hidden className="shrink-0 leading-none">
          {flagEmoji}
        </span>
      ) : null}
      <span className="min-w-0 text-sm font-normal leading-normal text-muted-foreground">
        {trimmedCity}
      </span>
    </div>
  );
}
